import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { lastRoutes, mainRoutes } from "./mainRoutes";
import UserStatus from "./../context/UserStatus";

function MainRoutes() {
  const userContext = useContext(UserStatus);
  const renderRoutes = () => {
    const routes = [...mainRoutes, ...lastRoutes];

    return routes.map((route, index) => {
      if (!route.component) {
        return (
          <Route
            path={route.path}
            key={index}
            element={
              <Navigate to={!route.id ? route.to : userContext?.isLoggedIn ? "/dashboard" : "/"} />
            }
          />
        );
      }
      return (
        <Route path={route.path} element={route.component} key={index}>
          {route.children &&
            route.children.length &&
            route.children.map((childRoute, childIndex) => {
              return (
                <Route path={childRoute.path} key={childIndex} element={childRoute.component} />
              );
            })}
        </Route>
      );
    });
  };

  return <Routes>{renderRoutes()}</Routes>;
}

export default MainRoutes;
